import authService from "../../../auth/AuthService";
import {apiActionsBillingReports, billingReportsActionTypes} from "../constants/BillingReportActionConstants";

const runUpdateLinks = (authToken) => ({
    type: apiActionsBillingReports.POST_UPDATE_LINKS,
    payload: {authToken}
});

const runMonthlyRollup = (date, authToken) => ({
    type: apiActionsBillingReports.POST_MONTHLY_ROLLUP,
    payload: {date, authToken}
});

const runSelectedBillingReport = (date, authToken) => ({
    type: apiActionsBillingReports.POST_BILLING_REPORT,
    payload: {date, authToken}
});

const runSelectedPricing = (date, authToken) => ({
    type: apiActionsBillingReports.POST_RUN_PRICING,
    payload: {date, authToken}
});

const getSelectedBillingReport = (date, authToken) => ({
    type: apiActionsBillingReports.GET_BILLING_REPORT,
    payload: {date, authToken}
});

const uploadSelectedSapFiles = (date, entropy, authToken) => ({
    type: apiActionsBillingReports.GET_UPLOAD_SAP_FILE,
    payload: {date, entropy, authToken}
});

const getSelectedSapIFile = (date, entropy, authToken) => ({
    type: apiActionsBillingReports.GET_SAP_INPUT_FILE,
    payload: {date, entropy, authToken}
});

const getSelectedSapUCFile = (date, entropy, authToken) => ({
    type: apiActionsBillingReports.GET_SAP_USAGE_CONTROL_FILE,
    payload: {date, entropy, authToken}
});

const getSapUploadStatus = (date, authToken) => ({
    type: apiActionsBillingReports.GET_SAP_UPLOAD_STATUS,
    payload: {date, authToken}
});

const updateSapUploadStatus = (data) => ({
    type: billingReportsActionTypes.UPDATE_SAP_UPLOAD_STATUS,
    payload: {data}
});

const showDbLoading = () => ({
    type: billingReportsActionTypes.SHOW_DB_LOADING
});

const showDsLoading = () => ({
    type: billingReportsActionTypes.SHOW_DS_LOADING
});

const showUlLoading = () => ({
    type: billingReportsActionTypes.SHOW_UL_LOADING
});

const showMrLoading = () => ({
    type: billingReportsActionTypes.SHOW_MR_LOADING
});

const showRpLoading = () => ({
    type: billingReportsActionTypes.SHOW_RP_LOADING
});

const showRbLoading = () => ({
    type: billingReportsActionTypes.SHOW_RB_LOADING
});

const showDownloadMessage = (data) => ({
    type: billingReportsActionTypes.SHOW_DOWNLOAD_MESSAGE,
    payload: {data}
});

const showRunMessage = (data) => ({
    type: billingReportsActionTypes.SHOW_RUN_MESSAGE,
    payload: {data}
});

const hideDownloadMessage = () => ({
    type: billingReportsActionTypes.HIDE_DOWNLOAD_MESSAGE
});

const hideRunMessage = () => ({
    type: billingReportsActionTypes.HIDE_RUN_MESSAGE
});

const toggleUploadSapWarningModal = () => ({
    type: billingReportsActionTypes.TOGGLE_UPDATE_SAP_WARNING
});

const unmountBillingReport = () => ({
    type: billingReportsActionTypes.CLEAR_BILLING_REPORT_DETAILS
});

export function updateLinks() {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(runUpdateLinks(authToken))
        dispatch(showUlLoading())
    }
}

export function monthlyRollup(date) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(runMonthlyRollup(date, authToken))
        dispatch(showMrLoading())
    }
}

export function runBillingReport(date) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(runSelectedBillingReport(date, authToken))
        dispatch(showRbLoading())
    }
}

export function runPricing(date) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(runSelectedPricing(date, authToken))
        dispatch(showRpLoading())
    }
}

export function getBillingReport(date) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getSelectedBillingReport(date, authToken))
        dispatch(showDbLoading())
    }
}

export function uploadSapFile(date, entropy) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(uploadSelectedSapFiles(date, entropy, authToken))
        dispatch(showDsLoading())
    }
}

export function getSapInputFile(date, entropy) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getSelectedSapIFile(date, entropy, authToken))
    }
}

export function getSapUsageControlFile(date, entropy) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getSelectedSapUCFile(date, entropy, authToken))
    }
}

export function getSapFileUploadStatus(date) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getSapUploadStatus(date, authToken))
    }
}

export function updateSapStatus(data) {
    return (dispatch) => {
        dispatch(updateSapUploadStatus(data))
    }
}

export function showDownloadResponseMessage(data) {
    return (dispatch) => {
        dispatch(showDownloadMessage(data))
    }
}

export function showRunResponseMessage(data) {
    return (dispatch) => {
        dispatch(showRunMessage(data))
    }
}

export function hideDownloadResponseMessage() {
    return (dispatch) => {
        dispatch(hideDownloadMessage())
    }
}

export function hideRunResponseMessage() {
    return (dispatch) => {
        dispatch(hideRunMessage())
    }
}

export function toggleSapUploadWarning() {
    return (dispatch) => {
        dispatch(toggleUploadSapWarningModal())
    }
}

export function unmountBillingReportComponent() {
    return (dispatch) => {
        dispatch(unmountBillingReport())
    }
}

const exports = {
    apiActionsBillingReports,
    billingReportsActionTypes,
}

export default exports;
